import gql from 'graphql-tag';

const WDT_CLASSROOM_PROGRESS_BY_CHARACTERS_QUERY = gql`
  query wdtClassroomProgressByCharactersReport(
    $where: WdtClassroomProgressByCharactersReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtClassroomProgressByCharactersReport(where: $where, dateRange: $dateRange) {
      classroomId
      characterOrder
      characterGroups {
        id
        name
      }
      characterProgress {
        character {
          id
          characterGroupIds
          character
        }
        characterLevelsProgress {
          level
          studentCompletedCount
        }
      }
    }
  }
`;

export default WDT_CLASSROOM_PROGRESS_BY_CHARACTERS_QUERY;
